export const ORDER_ITEMS_ERROR_DOMAIN_QUANTITY = 'quantity';

export const ORDER_ITEMS_ERROR_MESSAGE_QUANTITY = 'SKULIST_INVALID_QUANTITY';

export const ORDER_ITEMS_PACKAGE_ERROR_CODE = 'UPC5079';
